import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';
import { centsToDollars } from '../../utils';

type Props = {
  min: number;
  max: number;
  preSet: number;
  onDone: (amount: number) => void;
};

export function CustomAmountInput({ min, max, onDone, preSet }: Props) {
  const [open, setOpen] = useState(true);
  const [value, setvalue] = useState(0);
  return (
    <>
      <Transition.Root show={open} as={Fragment} appear>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {
            setOpen(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => {
              setOpen(false);
              onDone(value);
            }}
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative min-w-1/2 transform overflow-hidden rounded-lg bg-surface px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8  sm:p-6">
                  <form
                    onSubmit={e => {
                      e.preventDefault();
                      // @ts-ignore
                      console.log(e.target.amount.value);
                      // @ts-ignore
                      setvalue(e.target.amount.value);
                      setOpen(false);
                    }}
                  >
                    <p className="text-lg font-semibold text-on-surface ">
                      Enter custom amount
                    </p>
                    <p className="text-md italic text-on-surface">
                      Min amount: {centsToDollars(min)}
                    </p>
                    <p className="text-md italic text-on-surface">
                      Max amount: {centsToDollars(max)}
                    </p>
                    <input
                      required
                      min={min / 100}
                      max={max / 100}
                      name="amount"
                      type="number"
                      className="block w-full rounded-md mt-4 border-0 py-1.5 pl-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-container-600 sm:text-sm sm:leading-6"
                    />
                    <button
                      type="submit"
                      className="bg-primary-container rounded-md text-on-primary-container w-full py-2 mt-4 text-md font-semibold"
                    >
                      Submit
                    </button>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
